<script setup lang="ts">
/**
 * Use the framework.
 */
const { onlyRoots, framework, findChildren, fetchChildren } = useFramework()

/**
 * Top level dimensions.
 */
const dimensions = computed(() => {
    return onlyRoots(unref(framework))
})

/**
 * Fetch the children of top level dimensions.
 */
await Promise.all(unref(dimensions).map(item => fetchChildren(item.id)))

/**
 * Translations.
 */
const { t } = useI18n()
</script>

<template>
    <UiContainer class="min-h-full py-8">
            <div class="mb-8 flex flex-col gap-2">
            <h1 class="text-2xl font-bold uppercase text-black">
                {{ t('world-framework-title') }}
            </h1>
            <p class="font-serif">
                {{ t('world-framework-description') }}
            </p>
        </div>

        <div
            class="flex w-full flex-col flex-wrap items-start gap-12 lg:flex-row"
        >
            <div
                v-for="level in dimensions"
                :key="level.id"
                class="flex w-full flex-1 flex-col gap-2"
            >
                <UiHeading :title="level.name" :description="level.description">
                    <template #title="{ title }">
                        <span
                            class="px-2 py-1"
                            :style="coloringStyle(level.labelColor)"
                        >
                            {{ title }}
                        </span>
                    </template>
                </UiHeading>

                <template v-if="level.explanation">
                    <WorldFrameworkContent as="div" :level="level" open />
                </template>

                <template v-else>
                    <WorldFrameworkItem
                        v-for="sublevel in findChildren(level.id)"
                        :key="sublevel.id"
                        :level="sublevel"
                    />
                </template>
            </div>
        </div>
    </UiContainer>
</template>